var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    filter: "url(#filter0_d_4195_1276)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 17,
    r: 13,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M20.7562 15.25V15.15H20.6562H19.5625H19.4625V15.25V20.7188V20.8188H19.5625H20.6562H20.7562V20.7188V15.25ZM18.5687 15.25V15.15H18.4688H17.375H17.275V15.25V20.7188V20.8188H17.375H18.4688H18.5687V20.7188V15.25ZM25.1313 11.9688V11.8687H25.0312H21.85V11.6406C21.85 10.6808 21.0692 9.9 20.1094 9.9H17.9219C16.962 9.9 16.1813 10.6808 16.1813 11.6406V11.8687H13H12.9V11.9688V13.0625V13.1625H13H14.0613L15.0981 22.5518C15.1955 23.4344 15.9394 24.1 16.8281 24.1H21.2031C22.0918 24.1 22.8357 23.4344 22.9332 22.5518L23.97 13.1625H25.0312H25.1313V13.0625V11.9688ZM17.475 11.6406C17.475 11.3943 17.6756 11.1938 17.9219 11.1938H20.1094C20.3557 11.1938 20.5563 11.3943 20.5563 11.6406V11.8687H17.475V11.6406ZM21.6472 22.4098C21.6223 22.6356 21.4317 22.8062 21.2031 22.8062H16.8281C16.5996 22.8062 16.409 22.6356 16.384 22.4098L15.3629 13.1625H22.6684L21.6472 22.4098Z",
    fill: "#929AA6",
    stroke: "#929AA6",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4195_1276",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4195_1276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4195_1276",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.146a9c1594c609b45447f7fcabecd5fd.svg";
export { ForwardRef as ReactComponent };